/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
import React, { useState, useContext, useEffect } from 'react';
import { cloneDeep } from 'lodash-es';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { NestedMenuItem, ActionIcon } from '@mummssoftware/common-ui';
import { PalliativeCare } from '@mummssoftware/utils/constants';
import {
  GlobalContext,
  HCPCSGlobalContext,
  SET_HCPCS_CHOICE,
  DISABLE_HCPCS_MENU,
} from '@mummssoftware/global-context';
import { AppContext } from '../../../../context';
import { useStyles } from '../style';
import { iconStyle, ACP, PSY } from './constants';
import { MenuDiv } from './HCPCSWrapper';

export const HCPCSMenu = () => {
  const { editingPastVisit } = useContext(GlobalContext);
  const hcpcsMenu: any = window.env?.hcpcs || null;
  const keyRole = (
    (editingPastVisit as any)?.careProviderRoleGroup ||
    (editingPastVisit as any)?.rolegroupname
  )
    .toLowerCase()
    // remove white space
    .replace(/\s/g, '');

  const selectedMenu = hcpcsMenu && keyRole ? hcpcsMenu[keyRole] : [];
  const {
    dispatchHCPCS,
    hcpcsMapping,
    disabledHCPCSMenu,
    hcpcsDuration,
    icdCodeNames,
    icdSection,
  } = useContext(HCPCSGlobalContext);
  const { patient } = useContext(AppContext);
  const isPalCarePatient = patient?.programSiteName === PalliativeCare;

  const [hcpcsPhysMenu, setHCPCSPhysMenu] = useState<any>(selectedMenu);

  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const closeMenu = () => {
    setAnchorEl(null);
  };
  const openMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const setMenuItem = (item: any) => {
    setAnchorEl(null);
    dispatchHCPCS({
      type: SET_HCPCS_CHOICE,
      payload: item,
    });
  };

  const getACPMenu = (hcpcsKeys: any, menu: any) => {
    let updatedMenu = [...menu];
    hcpcsKeys.forEach((key: string) => {
      updatedMenu = updatedMenu.filter(
        (x: any) => x.key !== key && !x.key.includes(PSY),
      );
      // @note in case this changes one more time
      // updatedMenu = updatedMenu.map((x: any) => {
      //   if (x.key === key) {
      //     return { ...x, disabled: true };
      //   }
      //   if (x.key.includes(PSY)) {
      //     return { ...x, disabled: true };
      //   }
      //   if (key.includes(x.key)) {
      //     const newMenu = [...x.submenu].map((i: any) => ({
      //       ...i,
      //       disabled: true,
      //     }));
      //     x.submenu = newMenu;
      //   }
      //   return x;
      // });
    });
    return updatedMenu;
  };

  const getServicedMenu = (hcpcsKeys: any, menu: any) => {
    let updatedMenu = [...menu];
    hcpcsKeys.forEach((key: string) => {
      updatedMenu = updatedMenu.filter((x: any) => x.key === ACP);
    });
    return updatedMenu;
  };

  const getUpdatedMenuBeg = (hcpcsKeys: any, menu: any) => {
    // step 1 : select ACP first - can still select services
    if (hcpcsKeys && hcpcsKeys.length === 1 && hcpcsKeys.includes(ACP)) {
      const updatedMenu = getACPMenu(hcpcsKeys, menu);
      return updatedMenu;
      // step 2 : psychotherapy - can only be selected by itself
    } else if (
      hcpcsKeys &&
      hcpcsKeys.length === 1 &&
      hcpcsKeys[0].includes(PSY)
    ) {
      dispatchHCPCS({
        type: DISABLE_HCPCS_MENU,
        payload: true,
      });
      // step 3: services - can be selected with ACP
    } else if (
      hcpcsKeys &&
      hcpcsKeys.length === 1 &&
      // services
      hcpcsKeys[0].includes('S')
    ) {
      const updatedMenu = getServicedMenu(hcpcsKeys, menu);
      return updatedMenu;
    }
    dispatchHCPCS({
      type: DISABLE_HCPCS_MENU,
      payload: true,
    });
    return [];
  };

  /**
   * Disable the menu if duration or icd not ok
   */

  useEffect(() => {
    const mapKeys = hcpcsMapping && Object.keys(hcpcsMapping);
    const mapDuration =
      hcpcsDuration &&
      Object.values(hcpcsDuration) &&
      Object.values(hcpcsDuration).length &&
      Object.values(hcpcsDuration)[0] !== null;
    if (mapKeys && !mapKeys.length) {
      dispatchHCPCS({
        type: DISABLE_HCPCS_MENU,
        payload: false,
      });
      // step 1 : can only have max 2 menu items before being disabled
    } else if (mapKeys && mapKeys.length > 1) {
      dispatchHCPCS({
        type: DISABLE_HCPCS_MENU,
        payload: true,
      });
      // step 2: no duration entered
    } else if (mapKeys && mapKeys.length && !mapDuration) {
      dispatchHCPCS({
        type: DISABLE_HCPCS_MENU,
        payload: true,
      });
      // step 3: PSY menu
    } else if (mapKeys && mapKeys.length === 1 && mapKeys[0].includes(PSY)) {
      dispatchHCPCS({
        type: DISABLE_HCPCS_MENU,
        payload: true,
      });
      // step 4: menu selected and ICD
    } else if (mapKeys) {
      const hasICD =
        icdCodeNames &&
        Object.values(icdCodeNames) &&
        Object.values(icdCodeNames).length &&
        Object.values(icdCodeNames)[0].length;

      if (hasICD) {
        // step 5: ICD selected
        // is there a search box opened and no ICD code selected
        const menuKey = mapKeys[0];
        if (icdSection[menuKey] && icdSection[menuKey].length) {
          const icdArr = icdSection[menuKey].filter((x) => !x.hide);
          if (icdArr.length === icdCodeNames[menuKey].length) {
            dispatchHCPCS({
              type: DISABLE_HCPCS_MENU,
              payload: false,
            });
          } else {
            dispatchHCPCS({
              type: DISABLE_HCPCS_MENU,
              payload: true,
            });
          }
        }

        // No ICD selected
      } else {
        // is Pal Care patient
        if (isPalCarePatient) {
          // step 4: no ICD code selected
          dispatchHCPCS({
            type: DISABLE_HCPCS_MENU,
            payload: true,
          });
        } else {
          // non Pal Care patient
          if (Object.keys(icdSection).length) {
            const menuKey = mapKeys[0];
            if (icdSection[menuKey] && icdSection[menuKey].length) {
              const icdArr = icdSection[menuKey].filter((x) => !x.hide);
              if (icdArr.length) {
                dispatchHCPCS({
                  type: DISABLE_HCPCS_MENU,
                  payload: true,
                });
              } else {
                dispatchHCPCS({
                  type: DISABLE_HCPCS_MENU,
                  payload: false,
                });
              }
            }
          } else {
            dispatchHCPCS({
              type: DISABLE_HCPCS_MENU,
              payload: false,
            });
          }
        }
      }
    }
  }, [
    hcpcsMapping && Object.keys(hcpcsMapping).toString(),
    icdCodeNames && Object.values(icdCodeNames).toString(),
    hcpcsDuration && Object.values(hcpcsDuration).toString(),
    JSON.stringify(icdSection),
  ]);

  useEffect(() => {
    if (hcpcsMapping && Object.keys(hcpcsMapping).length) {
      const hcpcsKeys = Object.keys(hcpcsMapping);
      const menu = cloneDeep(selectedMenu);
      const updatedMenu = getUpdatedMenuBeg(hcpcsKeys, menu);
      setHCPCSPhysMenu(updatedMenu);
    } else {
      setHCPCSPhysMenu(selectedMenu);
    }
    // toString to avoid many re-renders
  }, [hcpcsMapping && Object.keys(hcpcsMapping).toString()]);

  const createMenu = (menuItems?: mumms.HCPCSCascadeMenu | null) =>
    menuItems && menuItems.length ? (
      <div>
        {menuItems.map((choice: mumms.HCPCSCascadeMenuItem, i: number) => (
          <MenuItem
            key={`choice-${i}`}
            disabled={choice.disabled}
            onClick={() => setMenuItem(choice)}
          >
            <MenuDiv color={choice.color}>{choice.name}</MenuDiv>
          </MenuItem>
        ))}
      </div>
    ) : (
      <div></div>
    );

  const createCascadeMenu = (menuItems?: mumms.HCPCSCascadeMenu | null) =>
    menuItems && menuItems.length ? (
      <div>
        {menuItems.map((choice: mumms.HCPCSCascadeMenuItem, i: number) =>
          choice.submenu ? (
            <NestedMenuItem
              label={choice.name}
              key={`choice-${i}`}
              parentMenuOpen={Boolean(anchorEl)}
              disabled={choice.disabled}
            >
              {createMenu(choice.submenu)}
            </NestedMenuItem>
          ) : (
            <MenuItem
              key={`choice-${i}`}
              onClick={() => setMenuItem(choice)}
              disabled={choice.disabled}
            >
              <MenuDiv color={choice.color}>{choice.name}</MenuDiv>
            </MenuItem>
          ),
        )}
      </div>
    ) : (
      <div></div>
    );

  return (
    <>
      <ActionIcon
        style={iconStyle}
        Icon={AddCircleIcon}
        onClick={openMenu}
        disabled={disabledHCPCSMenu}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        PaperProps={{
          classes: {
            elevation8: classes.introMenu,
          },
        }}
      >
        <div>{createCascadeMenu(hcpcsPhysMenu)}</div>
      </Menu>
    </>
  );
};
